export const mainArray = ( {}) => [
    {
      id: "id",
      name: "id",
      label: "BOL number",
    },
  ];

  